import React, { memo } from "react";
import { useTranslation, Trans } from "react-i18next";
import { P1 } from "@talentbait/shared-components";

import DraftCampaignStepLayout from "./DraftCampaignStepLayout";

const DraftCampaignAudienceInfoStep = (props) => {
  const { t } = useTranslation();

  return (
    <DraftCampaignStepLayout header={t("Reach your target audience 🎯")} {...props}>
      <Trans parent={P1}>
        Ad placement location directly affects <b>budget and channel composition</b>. As you add
        more locations, the budget increases to effectively reach your target audience throughout
        the campaign.
      </Trans>
      <Trans parent={P1}>
        Remember, each region has its unique social media behaviors. Therefore,{" "}
        <b>strategically choose locations</b> where your target audience is most active. Keep in
        mind, additional costs may arise for selecting more than two locations.
      </Trans>
    </DraftCampaignStepLayout>
  );
};

export default memo(DraftCampaignAudienceInfoStep);
